/**
 *
 * @module entry
 * @desc {SDK.Session} entry point.
 *
 */

import SessionManager from './sessionManager';

/**
 *
 * @typedef SDK.Session
 * @type {Object}
 *
 * @property {SessionManager} SessionManager
 *
 */

/**
 *
 * @type {SDK.Session}
 *
 */
export default {

    SessionManager

};



// WEBPACK FOOTER //
// ./src/session/entry.js